// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2_vaZ","tab":"ProcedureTabs_tab__3vrSa"};